import 'CssFolder/components/select-input-component.scss';
import { Icon, Icons, Intent } from "construct-ui";
import languageModel from "../../models/language.model";
import SelectModelAliasSearchInputDialog from './select-model-alias-search-input.dialog';

/**
 * Select Model Alias Search Input Component
 * 
 * Input for validation and display in forms, onclick calls SelectModelAliasSearchInputDialog
 * 
 * @author Darrus Goh 
 */
export default function SelectModelAliasSearchInputComponent() {
  const KEY_MODEL_CODE = 'modelAlias';

  let isDialogOpen = false;

  const openDialog = () => {
    isDialogOpen = true;
  };

  const closeDialog = () => {
    isDialogOpen = false;
  };

  const renderLabel = (selectedItems) => {
    if (selectedItems?.length > 0) {
      if (selectedItems?.length <= 3) {
        return selectedItems.map(item => item[KEY_MODEL_CODE]).join(', ');
      } else {
        return selectedItems.length + ' ' + languageModel.getText("LT00000308", "items selected");
      }
    }

    return '';
  };

  const renderTitle = (selectedItems) => {
    if (selectedItems?.length > 0) {
      return selectedItems.map(item => item[KEY_MODEL_CODE]).join('\r\n');
    }

    return '';
  };

  const readOnly = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return {
    view: ({ attrs: {
      disabled = false,
      selectedItems = [],
      selectedItem = null,
      multiple = false,
      onSelect,
      required = false,
      EULA,
      icon = Icons.LIST
    }
    }) => [
        m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
          class: disabled ? 'disabled ' : '',
          onclick: !disabled && openDialog
        },
          m('input.flex-fill.text-start.ps-0', {
            disabled,
            required,
            type: 'text',
            placeholder: languageModel.getText('LT00000201', 'Please Select'),
            oninput: readOnly,
            autocomplete: 'off',
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            value: renderLabel(multiple ? selectedItems : (selectedItem ? [selectedItem] : [])),
            title: renderTitle(multiple ? selectedItems : (selectedItem ? [selectedItem] : []))
          }),
          m(Icon, { name: icon, intent: Intent.PRIMARY })
        ),
        m(SelectModelAliasSearchInputDialog,
          {
            isOpen: isDialogOpen,
            selectedItems,
            selectedItem,
            onSelect,
            multiple,
            EULA,
            onClose: closeDialog
          }
        )
      ]
  };
}